import { CONTACT } from "../../data/site";

const WORDS = [
  "Handyman", "Painting", "Drywall", "Flooring", "TV Mounting", "Kitchens",
  "Bathrooms", "Trim & Doors", "Commercial", "Maintenance", "Renovations",
];

export const Marquee = () => (
  <div className="relative overflow-hidden border-y border-white/10 bg-ffc-blue py-5" data-testid="marquee">
    <div className="marquee">
      {[...Array(2)].map((_, k) => (
        <div key={k} className="flex items-center" aria-hidden={k === 1}>
          {WORDS.map((w) => (
            <span key={w + k} className="flex items-center">
              <span className="font-display px-6 text-2xl font-bold text-white/95 sm:text-3xl">{w}</span>
              <span className="h-2 w-2 rounded-full bg-ffc-red" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export const TrustBar = () => (
  <div className="bg-white py-6">
    <div className="mx-auto flex max-w-[1400px] flex-wrap items-center justify-center gap-x-8 gap-y-3 px-5 text-sm font-semibold text-ffc-gray lg:px-10">
      <span>Licensed & Insured</span><span className="text-ffc-red">•</span>
      <span>Satisfaction Guaranteed</span><span className="text-ffc-red">•</span>
      <span>Transparent Pricing</span><span className="text-ffc-red">•</span>
      <span>Serving {CONTACT.city}</span>
    </div>
  </div>
);
